import axiosInstance from "../../../api/axiosConfig";

export const getStockCategories = (params: any) => {
  return axiosInstance.get("/admin/stock-categories", {
    params: params,
  });
};

export const deleteStockCategory = (id: string) => {
  return axiosInstance.delete(`/admin/stock-categories/${id}`);
};
